import { render, staticRenderFns } from "./Breed.vue?vue&type=template&id=e3622c38&scoped=true&"
import script from "./Breed.vue?vue&type=script&lang=js&"
export * from "./Breed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3622c38",
  null
  
)

export default component.exports